import { Button, Divider, Form, FormInstance, Input, message, Modal, Space, Switch, Table } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";

const ComparisonProductNoticeEdit = (props: any) => {
    const formRef = useRef<FormInstance>(null);
    const { ...rest } = props;

    useEffect(() => {
        if (rest.isOpen) {
            switch (rest.viewMode) {
                case 0:
                    setData(null);
                    break;
                case 1:
                    getComparisonProductNotice();
                    break;
                case 2:
                    getComparisonProductNotice();
                    break;
            }

        }
    }, [rest.isOpen])

    const setData = (record: any) => {
        if (record) {
            formRef.current?.setFieldsValue(record);
        }
        else {
            formRef.current?.resetFields();
        }
    }

    const getComparisonProductNotice = () => {
        if (rest.comparisonProductNoticeID) {
            var params = {
                comparisonProductNoticeID: rest.comparisonProductNoticeID
            };
            Server.Post(URL.ComparisonProductNotice.GetComparisonProductNotice, params, false).then((response: any) => {
                if (response.isSuccess) {
                    setData(response);
                }
            })
        }
    }

    const handleCancel = () => {
        rest.setIsOpen(false);
    }

    const handleSave = () => {
        formRef.current?.validateFields().then((values => {
            var params = values;
            Server.Post(URL.ComparisonProductNotice.SaveComparisonProductNotice, params).then((response: any) => {
                if (response.isSuccess) {
                    message.success('保存成功');
                    rest.setIsOpen(false);
                    rest.loadData();
                } else {
                    message.warn(response.returnMsg);
                }
            })
        }));
    }

    return <Modal title={(rest.viewMode == 0 ? '新增' : '编辑') + "产品公告"} width={750} open={rest.isOpen} onCancel={handleCancel}
        maskClosable={false}
        bodyStyle={{ padding: 0, margin: 8 }}
        footer={
            <Space>
                <Button onClick={handleSave} type='primary'>保存</Button>
                <Button onClick={handleCancel}>关闭</Button>
            </Space>
        }>
        <Form ref={formRef}
            labelCol={{
                xs: { span: 24 },
                sm: { span: 4 }
            }} wrapperCol={{
                xs: { span: 24 },
                sm: { span: 20 }
            }}>
            <Form.Item style={{ marginBottom: '5px' }} hidden label={'产品公告ID'} name={'comparisonProductNoticeID'} initialValue={null}>
                <Input readOnly={rest.viewMode == 2} />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'标题'} name={'title'} initialValue={''} rules={[{ required: true, message: '请输入标题' }]}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'是否上线'} name={'isOnline'} initialValue={true} valuePropName={'checked'}>
                <Switch checked />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'内容'} name={'content'} initialValue={''} rules={[{ required: true, message: '请输入内容' }]}>
                <TextArea rows={10} showCount maxLength={4000} />
            </Form.Item>
        </Form>
    </Modal>
};
export default ComparisonProductNoticeEdit